import React, { useEffect, useMemo } from 'react';
import { Flex } from 'antd';
import { Outlet } from 'react-router-dom';

import { AutoBroadcastsTable } from '../components/AutoBroadcastsTable';
import {
    CommonFiltersProps,
    CommonTableProps,
} from '../../../interfaces/common.interface';
import { useFilters } from '../../../../shops/features/products/hooks/useFilters';
import { selectShopCurrent } from '../../../../shops/features/shops/store/shopSlice';
import { COMMON_FILTERS, FETCH_DELAY } from '../../../utils/common';
import { TableTitle } from '../../../views/Common/TableTitle';
import {
    BroadcastType,
    CreateOrEditButton,
} from '../../../views/Broadcasts/CreateOrEditButton';
import { BroadcastControls } from '../../../views/Broadcasts/BroadcastControls';
import { useAppSelector } from '../../../../../store';
import { AutoBroadcastProps } from '../service/autoBroadcast.interface';
import { useLazyReadAutoBroadcastsQuery } from '../service/autoBroadcasts.api';

export const AutoBroadcastsContainer = () => {
    const { updateFilters, filters, get, source, loading } = useFilters<
        CommonFiltersProps,
        AutoBroadcastProps
    >(useLazyReadAutoBroadcastsQuery, COMMON_FILTERS);

    const current = useAppSelector(selectShopCurrent);

    const tableProps = useMemo<
        CommonTableProps<AutoBroadcastProps, CommonFiltersProps>
    >(
        () => ({
            loading,
            source,
            filters,
            updateFilters,
        }),
        [loading, source, filters, updateFilters]
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (current.id) {
                const payload = {
                    ...filters,
                    types: [2, 3, 4],
                };

                get({ filters: payload, id: current.id }, true);
            }
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, get, current.id]);

    return (
        <Flex gap={24} vertical>
            <Flex
                justify={'space-between'}
                gap={16}
                align={'center'}
                vertical={false}
            >
                <CreateOrEditButton type={BroadcastType.AUTO} />
            </Flex>

            <BroadcastControls
                isLoading={loading}
                updateFilters={updateFilters}
                filters={filters}
            />

            <TableTitle title={'Триггерные рассылки'} />

            <AutoBroadcastsTable {...tableProps} />
            <Outlet />
        </Flex>
    );
};
